function romanNumeral(num) {
  if (!+ num)
    return false;

  var digits = String(+ num).split(""),
    key = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM", "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC", "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"],
    roman = "",
    i = 3;
  while (i--)
    roman = (key[+ digits.pop() + (i * 10)] || "") + roman;

  return Array(+ digits.join("") + 1).join("M") + roman;
}

/* ============================================================================
 * THE CLOCK LOGIC THAT LIVED HERE HAS MOVED to assets/delivery-clock.js.
 *
 * Deleted from this file (AUDIT: the FIFTH computation, and the one the audit
 * headline was about -- the spec had counted only three):
 *
 *   getCurrentTime()      dayjs().tz('America/Los_Angeles'), else `new Date()`
 *   getCutoffTime()       the 3rd of four AM/PM parsers (D8), whose `if
 *                         (!window.todaysCutoffTime) return currentDayjs.endOf('day')`
 *                         was the 23:59 fallback at the heart of D1
 *   nextDeliveryDate()    walked window.blockOutDates -- i.e. whatever header
 *                         published, exceptions wrongly folded in (D2)
 *   drawTimeUpdates()     ran on setInterval every 1000ms on EVERY page
 *
 * Also deleted, and worth naming because it was a LOADED GUN rather than a bug:
 *
 *   let calendar;         never assigned, so base.js:95 was permanently false
 *   let datepicker;       never assigned, so `typeof datepicker !== 'undefined'`
 *                         was permanently false
 *
 * Those two dangling declarations are the only reason D1 was latent instead of
 * live: they kept a 23:59 cutoff away from datepicker.setOptions({minDate}).
 * Anyone who "fixed" the obvious-looking dangling variable would have armed it
 * that same day. The consolidation removes the gun, not just the trigger.
 *
 * Nothing replaces this here. delivery-views.js drives the DOM, once, from one
 * decision -- and without a 1Hz interval on every page.
 * ========================================================================== */



function addToCart(maidProductID, original_price_in = null) {
  let id = $('input[name=upgradeRadio]:checked').val();

  if (id == null) {
    id = maidProductID;
  }

  let formData = {
    items: [
      {
        id: id,
        quantity: 1,
        properties: {}
      }
    ]
  };

  // Add discounted price as a property
  if (original_price_in !== null && !isNaN(original_price_in)) {
    formData.items[0].properties["original_price_in"] = `$${(parseFloat(original_price_in) / 100).toFixed(2)}`;
  }
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      // A FAILED ADD MUST NOT LOOK LIKE A SUCCESSFUL ONE.
      // Until 2026-07-27 this .then() redirected unconditionally, so Shopify's 422
      // -- e.g. "The product '<title>' is already sold out.", which is what EVERY
      // non-US shopper got while the catalog was not sellable in the international
      // market -- still walked the shopper to an EMPTY cart with no message.
      // A UK customer reported it as "Is your website currently down as I can't
      // seem to add anything to the basket?". Silence is the bug; the 422 was fine.
      if (response.ok) {
        window.location.href = "/cart";
        return;
      }
      try {
        if (window.umami && typeof window.umami.track === 'function') {
          // make it observable, so the next one shows up in the weekly pulse
          // instead of arriving as a text message from a customer
          window.umami.track('atc_fail', {
            status: response.status,
            path: location.pathname,
            variant: String(id)
          });
        }
      } catch (e) { /* telemetry must never block the buy path */ }
      return response.json().catch(() => ({})).then(data => {
        showAddToCartError(
          data.description || data.message ||
          "Sorry \u2014 we couldn't add that to your basket. Please call us and we'll take care of it."
        );
      });
    })
    .catch((error) => {
      console.error('Error:', error);
      showAddToCartError(
        "Sorry \u2014 we couldn't add that to your basket. Please check your connection, " +
        "or call us and we'll take care of it."
      );
    });
}

// Surfaces a buy-path failure where the shopper is actually looking.
// Deliberately dependency-free (no jQuery, no theme modal, no CSS file): this runs
// on the one code path where something has ALREADY gone wrong, so it must not be
// able to fail for a second reason.
function showAddToCartError(msg) {
  try {
    var id = 'atc-error-banner';
    var el = document.getElementById(id);
    if (!el) {
      el = document.createElement('div');
      el.id = id;
      el.setAttribute('role', 'alert');
      el.style.cssText =
        'position:fixed;left:50%;transform:translateX(-50%);bottom:1.25rem;z-index:2147483647;' +
        'max-width:min(92vw,34rem);padding:.9rem 1.1rem;border-radius:.5rem;background:#8a1c1c;' +
        'color:#fff;font:500 15px/1.45 system-ui,-apple-system,Segoe UI,sans-serif;' +
        'box-shadow:0 6px 24px rgba(0,0,0,.28);text-align:center;';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    clearTimeout(window.__atcErrTimer);
    window.__atcErrTimer = setTimeout(function () { if (el) el.remove(); }, 12000);
  } catch (e) {
    alert(msg);  // last resort -- the shopper MUST learn the add failed
  }
}

function deleteFromCart(id) {
  let formData = {
    updates: {
      [id]: 0
    }
  };
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      location.reload();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}